import {migrateConversations} from "./utils"
import {decrypt} from "../../../utils/crypto"

async function migrateUsernames(collection) {
    const cUsers = await collection.find({
        $or: [{username: {$exists: false}}, {username: null}]
    }).toArray()

    if (!cUsers.length) return 0

    const cUsersWithKpUser = cUsers.filter(cUser => cUser.kpUser)
    const users = await global.User.collection.find({
        _id: {$in: cUsersWithKpUser.map(cUser => cUser.kpUser)}
    }).toArray()
    const usernameByUserId = new Map(users.map(user => [user._id.toString(), user.username]))

    const operations = cUsers
        .map(cUser => ({
            _id: cUser._id,
            username: (cUser.kpUser && usernameByUserId.get(cUser.kpUser.toString())) || (cUser.mail && decrypt(cUser.mail))
        }))
        .filter(({username}) => !!username)
        .map(({_id, username}) => ({
            updateOne: {filter: {_id}, update: {$set: {username}}}
        }))

    if (!operations.length) return 0

    const result = await collection.bulkWrite(operations)
    return result.modifiedCount
}

async function migrateAllConversations(collection) {
    const cUsers = await collection.find({}).toArray()

    const operations = cUsers
        .map(cUser => {
            const set = {}
            migrateConversations(cUser, set)
            return {_id: cUser._id, set}
        })
        .filter(({set}) => Object.keys(set).length)
        .map(({_id, set}) => ({
            updateOne: {filter: {_id}, update: {$set: set}}
        }))

    if (!operations.length) return 0

    const result = await collection.bulkWrite(operations)
    return result.modifiedCount
}

async function applyJob() {
    const collection = global.app.C.CUser.collection

    const usernamesUpdated = await migrateUsernames(collection)
    const conversationsUpdated = await migrateAllConversations(collection)

    return {message: `${usernamesUpdated} nom(s) d'utilisateur backfillé(s), ${conversationsUpdated} conversation(s) adaptée(s)`}
}

export const job = {
    name: "adaptCUserCollection",
    title: "Adapter la collection CUser au nouveau modèle",
    execute: function(context, callback) {
        applyJob()
            .then(result => callback(null, result))
            .catch(callback)
    }
}
